import { configureStore } from "@reduxjs/toolkit";
import userInterfaceSlice from "../Slices/userInterfaceSlice";
import settingsSlice from "../Slices/settingsSlice";
import assetsSlice from "../Slices/assetsSlice";
import soundsSlice from "../Slices/soundsSlice";
import animationsSlice from "../Slices/animationsSlice";
import freeSpinsSlice from "../Slices/freeSpinsSlice";
import freeSpinAnimationsSlice from "../Slices/freeSpinAnimationsSlice";
import loadingProgressReducer from "../Slices/loadingProgressSlice";
import freeRoundsSlice from "../Slices/freeRoundsSlice";

// Universal slices (provider-agnostic)
import gameSettingsSlice from "../Slices/gameSettingsSlice";
import spinSlice from "../Slices/spinSlice";
import featureGameSettingsSlice from "../Slices/featureGameSettingsSlice";

const store = configureStore({
  reducer: {
    // Shared slices
    userInterface: userInterfaceSlice,
    settings: settingsSlice,
    animations: animationsSlice,
    sound: soundsSlice,
    assets: assetsSlice,
    freeSpins: freeSpinsSlice,
    freeSpinAnimations: freeSpinAnimationsSlice,
    loadingProgress: loadingProgressReducer,
    freeRounds: freeRoundsSlice,

    // Universal game slices (work with any RGS provider)
    game: gameSettingsSlice,
    spin: spinSlice,
    featureGame: featureGameSettingsSlice,
  },
});

export default store;
